/* eslint-disable eqeqeq */
import {
  ACCION_CORREO,
  ACCION_DESPLAZARSE,
  ACCION_ENLACE,
  ACCION_VIDEO,
  IDIOMAS,
  SECCIONES
} from 'utils/constants'

const YT_VIDEO_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
const URL_REGEX = /^(ftp|http|https):\/\/[^ "]+$/

/**
 * Función que realiza la validación de datos de una página.
 */
export const validacionesPagina = (pagina) => {
  let error

  if (!pagina.url.trim()) {
    error = 'El enlace de la página es obligatorio'
  }

  IDIOMAS.forEach(({ value: idioma }) => {
    // Titulo
    if (!pagina.opciones[idioma].titulo.trim()) {
      error = `El titulo de la página es obligatorio (${idioma})`
    }

    // Descripción
    if (!pagina.opciones[idioma].descripcion.trim()) {
      error = `La descripción de la página es obligatoria (${idioma})`
    }

    // Acciones - registrar correo
    if (
      pagina.secciones.main.accion != ACCION_CORREO.value &&
      !pagina.secciones.main[idioma].keyAccion.trim()
    ) {
      error = `La acción principal de la página no está completa (${idioma})`
    }

    if (
      pagina.secciones.footer.accion != ACCION_CORREO.value &&
      !pagina.secciones.footer[idioma].keyAccion.trim()
    ) {
      error = `La acción secundaria de la página no está completa (${idioma})`
    }

    // Acciones - desplazarse
    if (
      pagina.secciones.main.accion == ACCION_DESPLAZARSE.value &&
      !SECCIONES.some(({ value: seccion }) => pagina.secciones.main[idioma].keyAccion === seccion)
    ) {
      error = `La sección de scroll de la acción principal no es valida (${idioma})`
    }
    if (
      pagina.secciones.footer.accion == ACCION_DESPLAZARSE.value &&
      !SECCIONES.some(({ value: seccion }) => pagina.secciones.footer[idioma].keyAccion === seccion)
    ) {
      error = `La sección de scroll de la acción secundaria no es valida (${idioma})`
    }

    // Acciones - abrir enlace
    if (
      pagina.secciones.main.accion == ACCION_ENLACE.value &&
      !URL_REGEX.test(pagina.secciones.main[idioma].keyAccion.trim())
    ) {
      error = `El enlace de la acción principal no es valido (${idioma})`
    }

    if (
      pagina.secciones.footer.accion == ACCION_ENLACE.value &&
      !URL_REGEX.test(pagina.secciones.footer[idioma].keyAccion.trim())
    ) {
      error = `El enlace de la acción secundaria no es valido (${idioma})`
    }

    // Acciones - abrir video YT
    if (
      pagina.secciones.main.accion == ACCION_VIDEO.value &&
      !YT_VIDEO_REGEX.test(pagina.secciones.main[idioma].keyAccion.trim())
    ) {
      error = `El video de YouTube de la acción principal no es valido (${idioma})`
    }

    if (
      pagina.secciones.footer.accion == ACCION_VIDEO.value &&
      !YT_VIDEO_REGEX.test(pagina.secciones.footer[idioma].keyAccion.trim())
    ) {
      error = `El video de YouTube de la acción principal no es valido (${idioma})`
    }
  })

  // Productos(PAGOS)

  if (!pagina.productos[0].nombre.trim()) {
    error = 'El nombre del plan de la sección de pagos no es valido'
  }

  if (!pagina.productos[0].descripcion.trim()) {
    error = 'La descripción del plan de la sección de pagos no es valida'
  }

  if (!pagina.productos[0].precioUnitario || pagina.productos[0].precioUnitario === 0 || isNaN(pagina.productos[0].precioUnitario)) {
    error = 'El precio unitario del plan de la sección de pagos no es valido'
  }

  return error
}
